'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Hue() {
}
export { $c_Lio_intela_sites_intelacloud_content_Hue as $c_Lio_intela_sites_intelacloud_content_Hue };
$p = $c_Lio_intela_sites_intelacloud_content_Hue.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Hue;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Hue() {
}
export { $h_Lio_intela_sites_intelacloud_content_Hue as $h_Lio_intela_sites_intelacloud_content_Hue };
$h_Lio_intela_sites_intelacloud_content_Hue.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Hue.js.map
